/**
 * @fileoverview PUT handler for the "/app_settings/delete_api_key/:api_key" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appSettingsDeleteApiKeyCacheKeys } from "./constants";
import type { PutAppSettingsDeleteApiKeyProps, AppSettingsDeleteApiKeyResult } from "./types";

export const putAppSettingsDeleteApiKey = reactQueryMutationAdapter(
  appSettingsDeleteApiKeyCacheKeys,
  (props: PutAppSettingsDeleteApiKeyProps): Promise<AppSettingsDeleteApiKeyResult> => {
    return fetch(`/app_settings/delete_api_key/${props.apiKey}`, "PUT", props);
  }
);
